import { vehiclePayload } from '../payloadsStruture';
import { getCompanyDataToInitialValue } from './company';

export const setupVehiclePayload = ({ values, requestJsonData, vehicles }) => {
  const valuesCopy = {};

  if (values.documentos) valuesCopy.documentos = values.documentos;
  if (values.cdTipoEmpresa) valuesCopy.cdTipoEmpresa = values.cdTipoEmpresa;
  if (values.deCpfCnpj) valuesCopy.deCpfCnpj = values.deCpfCnpj;
  if (values.nmCompleto) valuesCopy.nmCompleto = values.nmCompleto;
  if (values.deObservacaoExclusao) valuesCopy.deObservacaoExclusao = values.deObservacaoExclusao;

  valuesCopy.veiculos = vehicles;

  if (requestJsonData) {
    if (requestJsonData.cdTipoEmpresa) {
      valuesCopy.cdTipoEmpresa = requestJsonData.cdTipoEmpresa;
    }
    if (requestJsonData.deCpfCnpj) {
      valuesCopy.deCpfCnpj = requestJsonData.deCpfCnpj;
    }
    if (requestJsonData.nmCompleto) {
      valuesCopy.nmCompleto = requestJsonData.nmCompleto;
    }
  }
  return valuesCopy;
};

export const setupVehicleInitialValues = (internalNewRequest) => {
  let tempValues = { ...vehiclePayload, ...getCompanyDataToInitialValue(internalNewRequest) };
  return tempValues;
}